import { render, staticRenderFns } from "./VIBANManagementPage.vue?vue&type=template&id=2275d4c1&scoped=true&"
import script from "./VIBANManagementPage.vue?vue&type=script&lang=js&"
export * from "./VIBANManagementPage.vue?vue&type=script&lang=js&"
import style0 from "./VIBANManagementPage.vue?vue&type=style&index=0&id=2275d4c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275d4c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2275d4c1')) {
      api.createRecord('2275d4c1', component.options)
    } else {
      api.reload('2275d4c1', component.options)
    }
    module.hot.accept("./VIBANManagementPage.vue?vue&type=template&id=2275d4c1&scoped=true&", function () {
      api.rerender('2275d4c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/VIBANManagementPage.vue"
export default component.exports